module.exports = __webpack_public_path__ + "static/assets/3df8a3bc99dfd85c4d35d86095680637.svg";